import MainAppBar from "../../components/atoms/appbar/MainAppbar";
import * as React from "react";
import DateStrip from "../../components/layout/reservation/DateStrip";
import ReservationSearchLayout from "../../components/layout/reservation/ReservationSearch";
import dayjs from "dayjs";
import { useLoginInfo } from "../../hooks/useLoginInfo";
import { LOGIN_DIALOG_LABEL } from "../../lib/constants/common.constants";
import { useModalStore } from "../../lib/store/useModalStore";
import { useRouter } from "../../hooks/useRouter";

export default function Reservation() {
  const { isLoggedIn } = useLoginInfo();
  const { openModal } = useModalStore();
  const { push } = useRouter();

  const [selectedDate, setSelectedDate] = React.useState(
    dayjs().format("YYYYMMDD"),
  );

  React.useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  React.useEffect(() => {
    if (!isLoggedIn) {
      openModal("CONFIRM_DIALOG", {
        title: LOGIN_DIALOG_LABEL.title,
        content: LOGIN_DIALOG_LABEL.content,
        onClick: () => push("/login"),
      });
    }
  }, [isLoggedIn, openModal, push]);

  return (
    <div className="inset-0 bg-[#f5f5f5] relative flex flex-col h-full overflow-hidden overscroll-none">
      <MainAppBar title="골프장 예약" search={false} />
      <div className="z-10 absolute top-[56px] left-0 w-full h-[60px] bg-gradient-to-t from-transparent to-white pointer-events-none" />

      <div className="z-20">
        <DateStrip value={selectedDate} onChange={setSelectedDate} />
      </div>

      <div className="flex-1 min-h-0 p-[15px]">
        <ReservationSearchLayout date={selectedDate} />
      </div>
    </div>
  );
}
